import React from "react";
import { BG_PORTRAIT_URL, BG_URL } from "../lib/brand";

// Backdrop shared by the menu pages. The parent must be `relative`; `dim`
// tones it down behind dense content. On a page that scrolls (Lobby), pass
// `fixed` and make the parent `isolate` so the backdrop stays put behind it.
export const BrandBackground = ({ dim = false, fixed = false }) => (
  <div className={`${fixed ? "fixed -z-10" : "absolute"} inset-0 pointer-events-none`} aria-hidden="true">
    {/* `contents`: the picture element itself takes no box, so the image
        still fills the backdrop. */}
    <picture className="contents">
      <source media="(orientation: portrait)" srcSet={BG_PORTRAIT_URL} />
      <img src={BG_URL} alt="" className={`h-full w-full object-cover ${dim ? "opacity-60" : ""}`} />
    </picture>
    {/* Keeps the header and footer text readable over the pattern */}
    <div className="absolute inset-0 bg-gradient-to-b from-slate-950/75 via-slate-950/20 to-slate-950/85" />
  </div>
);

export default BrandBackground;
